import React from 'react';

import { Select, normalizeSelectValue } from '@gogame/components';

import Filter from '../Filter';
import getTitle from '../getTitle';

const FilterSelect = ({
  title,
  name,
  source,
  depends,
  withClear,
  withFavoriteActions,
  placeholder,
  disabled,
  disableEmpty,
  isOptionDisabled,
  multiFields,
  actions,
  compareActions,
  lazy,
  suffix,
  required,
  renderValue,
  renderOption,
  dropdownWidth,
  ['data-cy']: dataCy,
  serverSideSearch = false,
}) => {
  return (
    <Filter
      title={getTitle(title, required)}
      required={required}
      name={name}
      source={source}
      depends={depends}
      withClear={withClear}
      withFavoriteActions={withFavoriteActions}
      normalizeValue={normalizeSelectValue}
      multiFields={multiFields}
      actions={actions}
      compareActions={compareActions}
      lazy={lazy}
      suffix={suffix}
      disabled={disabled}
      disableEmpty={disableEmpty}
      serverSideSearch={serverSideSearch}
      renderComponent={({
        label,
        value,
        options,
        loading,
        fetching,
        onChange,
        onFocus,
        actions,
        error,
        onSearch,
        onClose,
        searchOptions,
        minOptionCountForSearch,
        postFiltering,
        suffix,
        disabled,
      }) => (
        <Select
          data-cy={dataCy || name}
          label={label}
          value={value}
          options={options}
          searchOptions={searchOptions}
          loading={loading}
          fetching={fetching}
          onChange={onChange}
          onFocus={onFocus}
          actions={actions}
          suffix={suffix}
          placeholder={placeholder}
          displayPlaceholder={true}
          disabled={disabled}
          isOptionDisabled={isOptionDisabled}
          renderValue={renderValue}
          renderOption={renderOption}
          dropdownWidth={dropdownWidth}
          error={error}
          variant={'outlined'}
          padding={0}
          onSearch={onSearch}
          onClose={onClose}
          minOptionCountForSearch={minOptionCountForSearch}
          postFiltering={postFiltering}
        />
      )}
    />
  );
};

export default FilterSelect;
